<template>
  <div class="wrapper wrapper_wide section_content">
    <div class="frame_wide separetor">
      <Feature v-bind='about.greet' :name="'about'"/>
    </div>
    <div class="frame_center">
      <GreetingDetail />
      <Fusion />
      <Consultation />
    </div>
  </div>
</template>

<script>
// organisms
import Feature from '../organisms/about_feature.vue'
import Fusion from '../organisms/fusion.vue'
import GreetingDetail from '../organisms/greetingDetail.vue'
import Consultation from '../organisms/consultation.vue'

import { mapState } from 'vuex'

export default {
  name: 'AboutContents',
  components: {
    Feature,
    Fusion,
    GreetingDetail,
    Consultation
  },
  props: {
    msg: String
  },
  data () {
    return {
      about: siteData.about,
      info: siteData.info,
      detail: siteData.detail
    }
  },
  comuputed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
